export default {
  home: {
    minute: "minut",
    price_info: 'Primele {mianfei} minute sunt gratuite. Taxa maximă pentru 24 de ore este de {currencyName}{fengding}. Depozitul dvs. de {currencyName}{yajin} va fi rambursat automat după ce returnați banca de energie',
    feature_1: 'Include toate tipurile de cabluri: iPhone, Type-C și Micro-USB',
    feature_2: 'Poate fi returnat la orice stație',
    feature_3: 'Încărcare fără fir disponibilă',
    tips_1: 'Depozitul dvs. {currencyName}{yajin} va fi returnat la sfârșitul închirierii',
    // tips_1: 'A deposit of {currencyName}{yajin} needs to be recharged before renting if the balance is insufficient',
    tips_2: 'Depozitul de reîncărcare {currencyName}{yajin} poate fi folosit pentru închiriere, iar atunci când este epuizat poate fi rambursat',
    tips_3: 'Soldul curent este {currencyName}{myyue}, care poate fi folosit direct pentru închiriere',
    submit: 'Începeți închirierea',
    borrow: "Chirie",
    msg_fail_title: 'Eroare',
    msg_fail_content: 'Închirierea a eșuat, vă rugăm să încercați din nou',
    msg_rentcount: 'În prezent aveți {zujieNum} comenzi care nu sunt închise',
    goborrow: 'Du-te la încărcare!!!',
    nearby: 'Vedeți stațiile din apropiere',
    preauth: 'Preautorizare'
  },
  login: {
    code_title: 'Verificare',
    phone_number: "Număr de telefon",
    verification_code: 'Vă rugăm să introduceți codul de verificare',
    captcha_code: 'Cod',
    send_code: "Trimite codul",
    login: "Log in",
    agree: "Făcând clic pe Conectare, sunteți de acord cu ",
    readme: "Acordul Utilizatorului",
    msg_fail_login: "Autentificare eșuată",
    msg_success_login: "Autentificare reușită",
    msg_fail_user: 'Eroare la obținerea informațiilor despre utilizator. Doriți să încercați din nou?',
    sign_in_with: "Logheaza-te cu",
    no_sms: 'Nu am primit mesajul text',
    retry: 'Retrimiteți',
    email: "E-Mail"
  },
  confirm: {
    deletecard: 'Ștergeți cardul',
    addcard: 'Introduceți detaliile cardului',
    title: "Confirmarea platii",
    paynow: "Plată imediată",
    SMSConfirm: 'Plătiți conform mesajului text primit pe telefon și faceți clic pe butonul de confirmare pentru a continua.',
    pay_label: "Cantitate",
    auth_label: 'Preautorizare',
    price_tips: 'Soldul dvs. poate fi retras dacă este solicitat. Este posibil să dureze 1-5 zile lucrătoare pentru a apărea în contul dvs. de plăți.',
    auth_tips: 'O sumă de preautorizare de {0}{1} este obligatorie. Suma reală de închiriere va fi dedusă atunci când banca de alimentare este returnată.',
    pay_type: 'Vă rugăm să selectați metoda de plată preferată',
    submit: "Confirma plata",
    msg_loading: "Se încarcă...",
    msg_fail_title: "Avertizare",
    msg_fail_payment: 'Nu s-a inițiat plata depozitului',
    msg_fail_order: 'Nu s-a putut crea o comandă de închiriere',
    msg_fail_support: 'Sistemul nu este acceptat',
    msg_fail_confirm: "A confirma",
    msg_fail_retry: 'Reîncercați',
    msg_fail_cancel: "Anulare"
  },
  mine: {
    title: 'Profil utilizator',
    wallet: "Portofelul meu",
    balance: 'Soldul meu',
    deposit: 'Depozit',
    wallet_in: 'Încărcare',
    wallet_out: "Retragere",
    wallet_log: 'Jurnal portofel',
    order: "Ordin",
    coupon: 'Cupon',
    login_tips: "Va rugam sa va logati",
    msg_fail_title: 'Eroare',
    msg_fail_update: 'Modificarea eșuată. Vă rugăm să încercați din nou',
    msg_loading: "Se încarcă...",
    msg_fail_user: 'Eroare la obținerea informațiilor despre utilizator. Doriți să încercați din nou?',
    help: "Ajutor",
    setting: 'Setare',
    logout: 'Deconectare',
    buy: 'Cumpărați echipament'
  },
  msg: {
    appoffline: "Aplicația nu a fost lansată încă, vă rugăm să așteptați",
    deletecard: 'Sunteți sigur că doriți să ștergeți acest card?',
    no_phone: 'Numărul de telefon este necesar',
    loading: "Se încarcă...",
    title: 'Sugestie',
    success: 'Operațiune reușită',
    error: 'Eroare necunoscută. Vă rugăm să încercați din nou mai târziu',
    roleerror: "Permisiuni insuficiente. Vă rugăm să consultați administratorul.",
    neterror: 'Conexiunea la rețea a eșuat. Vă rugăm să încercați din nou mai târziu',
    confirm: "A confirma",
    retry: 'Reîncercați',
    cancel: "Anulare",
    title_fail: "Avertizare",
    vieworder: "Vezi comanda",
    success_payment: 'Plată finalizată',
    success_buy: 'Achiziție finalizată',
    fail_payment: 'Eșec de plată',
    keyword: 'Cuvânt cheie',
    ispayorder: 'Vă rugăm să confirmați dacă plata a fost efectuată',
    unpay: 'Neplătit',
    yespay: 'Plătit',
    notopen: 'Nu este încă deschis'
  },
  result: {
    tips: 'Pentru a vizualiza comenzile și alte locații ale stațiilor, vă rugăm să descărcați aplicația.',
    download: "Descarca",
    title: 'Închiriere confirmată',
    gotit: "Am înţeles",
    price_plan: 'Standard de încărcare',
    msg_success: 'Închiriat cu succes',
    msg_tips_loading: 'Banca de alimentare este scoasă, vă rugăm să așteptați..',
    msg_result_loading: 'Rezultatul plății este în curs de confirmare...',
    msg_fail_confirm: "A confirma",
    btn_usage: 'Notă de utilizare',
    btn_return: 'Notă de returnare',
    deposit: 'Depozit',
    msg_fail_content: "Solicitarea a eșuat. Vă rugăm să încercați din nou.",
    price_label: "pe ora",
    price_info: 'Gratuit pentru primele {mianfei} minute, o taxă zilnică maximă de {currency}{finding}. Depozitul va fi dedus automat când chiria ajunge la {valută}{yajin}',
    tips_1: 'Vă rugăm să colectați banca de putere nr.{număr} așa cum se arată în imagine',
    tips_2: 'Vă rugăm să organizați cablurile și să introduceți power bank-ul în slot cu partea marcată cu [săgeți în jos]',
    msg_note_usage: 'Banca de alimentare este echipată cu 3 tipuri de cabluri, vă rugăm să alegeți cel de care aveți nevoie pentru dispozitivul dvs.',
    msg_note_return: 'Vă rugăm să organizați cablurile și să introduceți power bank-ul în slot cu partea marcată cu [săgeți în jos]',
    return_info: 'La întoarcere, asigurați-vă că cablurile sunt bine aranjate și introduceți partea cu așchii de metal într-o priză disponibilă până când ajunge în partea de jos și se stabilizează.'
  },
  result_msg: {
    loading: "Se încarcă...",
    refresh: 'Reîmprospătare'
  },
  order: {
    title: "Comandă de închiriere",
    in_use: "In folosinta",
    ended: 'Încheiat',
    msg_error: "Cerere nereusita"
  },
  order_item: {
    order_number: "Nu.",
    venue_rented: 'Locația de preluare',
    time_rented: 'Ora de ridicare',
    venue_returned: 'Locația de întoarcere',
    time_returned: 'Ora de întoarcere',
    charge_standard: 'Standard de încărcare',
    charge_standard_info: '{pJifei} {pCurrency} pe oră (primele {pMian} minute gratuit)',
    rent_occurred: 'A avut loc închirierea',
    returned: "Întors",
    unreturned: 'Nereturnat',
    type_0: "Incomplet",
    type_1: 'Închiriere',
    type_2: 'Anulat',
    type_3: "Întors",
    type_4: "A apărut o eroare",
    type_5: "Peste orar",
    min: "Min",
    payment: 'Plată'
  },
  setting: {
    title: 'Setare',
    lang: "Limba"
  },
  help: {
    title: "FAQ"
  },
  wallet_in: {
    title: 'Reîncărcare echilibru',
    price_label: 'Suma de reîncărcare',
    price_placeholder: 'Vă rugăm să introduceți suma de reîncărcare',
    balance: "Sold curent",
    price_auto: 'Alegeți suma de plată',
    price_tips: "Soldul dvs. poate fi retras la cerere. Poate dura 1-5 zile lucrătoare pentru a apărea în contul dvs. de plăți.",
    submit: "Trimite",
    loading: "Se încarcă...",
    paying: "Redirecționare către pagina de plată..",
    msg_title: "Sfaturi",
    msg_fail_order: 'Nu s-a putut crea comanda de reîncărcare',
    msg_fail_payment: 'Nu s-a inițiat plata reîncărcării',
    msg_fail_retry: 'Reîncercați'
  },
  wallet_out: {
    title: 'Retragere',
    price_label: "Suma de retragere",
    price_placeholder: 'Vă rugăm să introduceți suma de retragere',
    balance: "Sold curent",
    balance_all: "Retrageți totul",
    deposit: 'Depozit',
    deposit_tips: 'Există o comandă de închiriere restante. Depozitul de Ksh{pyajin} este nerambursabil',
    submit: "Trimite",
    apply: "Aplica",
    confirm: "A confirma",
    loading: "Se încarcă...",
    msg_fail_price: 'Suma de retragere este incorectă',
    msg_fail_balance: 'Suma de retragere nu poate depăși soldul curent',
    msg_fail_submit: 'Vă rugăm să completați toate informațiile solicitate',
    msg_title: 'Eroare',
    msg_success_content: 'Rambursare cu succes',
    confirmtitle: "Sfaturi",
    confirmcontent: 'Portofelul actual nu acceptă retragerea de numerar. Vă rugăm să înregistrați informațiile de contact pentru procesarea manuală a rambursării',
    payee_name: "Numele beneficiar",
    payee_bankcard: 'Numărul cardului bancar',
    payee_phone: 'Telefon',
    cancelText: "Anulare",
    confirmText: 'Reaplicați'
  },
  map: {
    在线: "Pe net",
    离线: "Deconectat",
    title: 'Gara din apropiere',
    result_msg: 'Nu a fost găsită nicio stație în apropiere',
    msg_title: 'eroare',
    no_support: "Ne pare rău! Browserul dvs. nu acceptă serviciile de localizare",
    my_position: "Locatia mea",
    distance: "Distanța:",
    shop_time: 'Ore',
    free: 'Disponibil pentru închiriere',
    return: 'Sloturi libere disponibile',
    shop_title: 'Detalii locație',
    address: "Abordare",
    go_here: "Du-te aici"
  }
};
